"use client";
import clsx from "clsx";
import * as React from "react";
import * as AvatarPrimitive from "@radix-ui/react-avatar";

const Avatar = ({ className, ...props }: React.ComponentProps<typeof AvatarPrimitive.Root>) => (
  <AvatarPrimitive.Root
    className={clsx("relative flex h-9 w-9 shrink-0 overflow-hidden rounded-full", className)}
    {...props}
  />
);

const AvatarImage = ({ className, ...props }: React.ComponentProps<typeof AvatarPrimitive.Image>) => (
  <AvatarPrimitive.Image className={clsx("aspect-square h-full w-full", className)} {...props} />
);

const AvatarFallback = ({ className, ...props }: React.ComponentProps<typeof AvatarPrimitive.Fallback>) => (
  <AvatarPrimitive.Fallback
    className={clsx("bg-muted flex h-full w-full items-center justify-center rounded-full", className)}
    {...props}
  />
);

export { Avatar, AvatarImage, AvatarFallback };
